import React, { useState, useRef } from "react";
import NavBar from "../components/NavBar";
import emailjs from "@emailjs/browser";
import { useToasts } from "react-toast-notifications";

const Contacte = () => {
  const { addToast } = useToasts();
  const [email, setEmail] = useState("");
  const [nom, setNom] = useState("");
  const [tel, setTel] = useState("");
  const [message, setMessage] = useState("");

  const formRef = useRef(); // Crée une référence pour le formulaire

  const sendMail = (ev) => {
    ev.preventDefault();
  
    // Utilisation de la méthode sendForm avec la référence du formulaire
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          addToast("Envoyé avec succès", {
            appearance: "success",
            autoDismiss: "true",
          });
          console.log("SUCCESS!");
          // Réinitialisation des champs après envoi réussi
          setEmail("");
          setNom("");
          setTel("");
          setMessage("");
        },
        (error) => {
          addToast(
            "Une erreur s'est produite, envoyez-moi un message sur randrianirinagervais5@gmail.com",
            {
              appearance: "error",
              autoDismiss: "true",
            }
          );
          setEmail("");
          setNom("");
          setTel("");
          setMessage("");
          console.log("FAILED...", error);
        }
      );
  };

  return (
    <>
      <NavBar />
      <section className="py-5">
        <div className="container px-5">
          <div className="bg-light rounded-4 py-5 px-4 px-md-5">
            <div className="text-center mb-5">
              <div className="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 mb-3">
                <i className="bi bi-envelope"></i>
              </div>
              <h1 className="fw-bolder">Entrez en contact</h1>
              <p className="lead fw-normal text-muted mb-0">
                Travaillons ensemble!
              </p>
            </div>
            <div className="row gx-5 justify-content-center">
              <div className="col-lg-8 col-xl-6">
                <form
                  id="contactForm"
                  ref={formRef} // Associe la référence au formulaire
                  onSubmit={sendMail}
                >
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="name"
                      name="from_name" // Nom du champ correspondant au template EmailJS
                      type="text"
                      placeholder="Entrer votre nom..."
                      data-sb-validations="required"
                      value={nom}
                      onChange={(ev) => setNom(ev.target.value)}
                      required
                    />
                    <label htmlFor="name">Nom complet</label>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="name:required"
                    >
                      Ce champ est requise.
                    </div>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="email"
                      name="from_email" // Nom du champ correspondant au template EmailJS
                      type="email"
                      placeholder="name@example.com"
                      data-sb-validations="required,email"
                      value={email}
                      onChange={(ev) => setEmail(ev.target.value)}
                      required
                    />
                    <label htmlFor="email">Email </label>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="email:required"
                    >
                      L'Email est requise.
                    </div>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="email:email"
                    >
                      L'Email est invalide.
                    </div>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="phone"
                      name="phone" // Nom du champ correspondant au template EmailJS
                      type="tel"
                      placeholder="Téléphone"
                      data-sb-validations="required"
                      value={tel}
                      onChange={(ev) => setTel(ev.target.value)}
                    />
                    <label htmlFor="phone">Téléphone</label>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="phone:required"
                    >
                      Téléphone requise.
                    </div>
                  </div>
                  <div className="form-floating mb-3">
                    <textarea
                      className="form-control"
                      id="message"
                      name="message" // Nom du champ correspondant au template EmailJS
                      placeholder="Entrer un message..."
                      style={{ height: "10rem" }}
                      data-sb-validations="required"
                      value={message}
                      onChange={(ev) => setMessage(ev.target.value)}
                      required
                    ></textarea>
                    <label htmlFor="message">Message</label>
                    <div
                      className="invalid-feedback"
                      data-sb-feedback="message:required"
                    >
                      Message requise.
                    </div>
                  </div>
                  <div className="d-none" id="submitSuccessMessage">
                    <div className="text-center mb-3">
                      <div className="fw-bolder">
                        Votre message été envoyé avec succès
                      </div>
                    </div>
                  </div>
                  <div className="d-none" id="submitErrorMessage">
                    <div className="text-center text-danger mb-3">
                      Une erreur s'est produit. Ressayer plus tard
                    </div>
                  </div>
                  <div className="d-grid">
                    <button
                      className="btn btn-primary btn-lg"
                      id="submitButton"
                      type="submit"
                    >
                      Envoyer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contacte;
